import { isArray } from 'lodash-es';
import React, { useEffect } from 'react';

import { Button, Popper } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';

import useStyles from './styles';

interface ButtonProps {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    label?: React.ReactNode;
    icon?: React.ReactNode;
}

interface Props {
    element: MayBeNil<Element>;
    progress?: React.ReactNode;
    nextButton?: ButtonProps;
    backButton?: ButtonProps;
    title?: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
}

const FeatureItem: React.FC<Props> = ({ element, title, description, nextButton, backButton, progress, className }) => {
    const { classes, cx } = useStyles();

    useEffect(() => {
        if (element) {
            element.classList.add(classes.elevation);
        }
        return () => {
            if (element) {
                element.classList.remove(classes.elevation);
            }
        };
    }, [classes.elevation, element]);

    return (
        <Popper open={!!element} anchorEl={element} className={cx(classes.popper, className)} placement="auto">
            <div className={classes.card}>
                {title ? <p className={classes.title}>{title}</p> : null}
                {description ? (
                    <div className={classes.description}>
                        {isArray(description) ? (
                            <ul>
                                {description.map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                        ) : (
                            description
                        )}
                    </div>
                ) : null}
                <div className={classes.line}>
                    {progress ? <span className={classes.progress}>{progress}</span> : null}
                    <div className={cx(classes.line, classes.buttons)}>
                        {backButton ? (
                            <Button
                                variant="contained"
                                size="medium"
                                fullWidth
                                disableFocusRipple
                                centerRipple
                                disableElevation
                                onClick={backButton.onClick}
                                startIcon={backButton.icon}
                                disabled={backButton.disabled}
                                className={cx(classes.button, classes.back)}
                            >
                                {backButton.label || 'Back'}
                            </Button>
                        ) : null}
                        {nextButton ? (
                            <Button
                                variant="contained"
                                size="medium"
                                fullWidth
                                disableFocusRipple
                                centerRipple
                                disableElevation
                                onClick={nextButton.onClick}
                                endIcon={nextButton.icon}
                                disabled={nextButton.disabled}
                                className={cx(classes.button, classes.next)}
                            >
                                {nextButton.label || 'Back'}
                            </Button>
                        ) : null}
                    </div>
                </div>
            </div>
        </Popper>
    );
};

export default FeatureItem;
